import { AppBar, IconButton, Toolbar } from '@mui/material';
import { RollLogoMiniImage } from 'assets/images';

const PublicAppBar = () => {
  return (
    <AppBar
      position="sticky"
      color="transparent"
      sx={{
        boxShadow: 'none',
        background: '#272727',
        width: 'auto',
        display: { xs: 'none', md: 'flex' },
      }}
    >
      <Toolbar
        variant="dense"
        color="info"
        sx={{
          justifyContent: { xs: 'space-between', md: 'flex-start' },
          padding: { xs: '0 12px', md: '25px 0 15px 12px' },
          width: '250px',
        }}
      >
        <IconButton
          color="inherit"
          aria-label="back"
          sx={{
            mr: 2,
            paddingLeft: { md: 0 },
          }}
        >
          <RollLogoMiniImage style={{ width: '142px', height: '28px' }} />
        </IconButton>
      </Toolbar>
    </AppBar>
  );
};

export default PublicAppBar;
